import React from "react";
import { Button, Space, Typography } from "antd";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import type { PickableGame } from "../../services/admin";
import {
  MAX_DESAFIO_GAMES,
  RECOMMENDED_DESAFIO_GAMES,
  gameKey,
  gameLine,
  moveGame,
} from "./desafios";

interface Props {
  value: PickableGame[];
  onChange?: (games: PickableGame[]) => void;
  readOnly?: boolean;
  /** Cabeçalho da lista; a tela de Treinos reaproveita o componente. */
  title?: string;
}

export const DesafioGameOrder: React.FC<Props> = ({
  value,
  onChange,
  readOnly = false,
  title = "Ordem do desafio",
}) => (
  <div>
    {!readOnly && (
      <div style={{ marginBottom: 8 }}>
        <Typography.Text
          strong
        >{`${title} (${value.length}/${MAX_DESAFIO_GAMES})`}</Typography.Text>
        <br />
        <Typography.Text type="secondary">{`Recomendado: ${RECOMMENDED_DESAFIO_GAMES} jogos`}</Typography.Text>
      </div>
    )}
    {value.length === 0 ? (
      <Typography.Text type="secondary">
        Nenhum jogo selecionado.
      </Typography.Text>
    ) : (
      value.map((g, i) => {
        const nome = g.titulo ?? gameKey(g);
        return (
          <div
            key={gameKey(g)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "4px 0",
            }}
          >
            <span>{gameLine(i + 1, g)}</span>
            {!readOnly && (
              <Space size={4}>
                <Button
                  size="small"
                  aria-label={`Subir ${nome}`}
                  icon={<ArrowUpOutlined />}
                  disabled={i === 0}
                  onClick={() => onChange?.(moveGame(value, i, -1))}
                />
                <Button
                  size="small"
                  aria-label={`Descer ${nome}`}
                  icon={<ArrowDownOutlined />}
                  disabled={i === value.length - 1}
                  onClick={() => onChange?.(moveGame(value, i, 1))}
                />
                <Button
                  size="small"
                  aria-label={`Remover ${nome}`}
                  icon={<DeleteOutlined />}
                  onClick={() =>
                    onChange?.(value.filter((_, idx) => idx !== i))
                  }
                />
              </Space>
            )}
          </div>
        );
      })
    )}
  </div>
);

export default DesafioGameOrder;
